export default "__VITE_ASSET__BQoE6AfF__"